module.exports = __webpack_public_path__ + "img/badge-most-created-leads-bronze.241cf8af.png";